'use strict';

import Collection from './collection.js';
import User from 'newModels/user.js';

export default class Users extends Collection {
    url() {
        if (this.user && this.user.get('role') === 'mpp_admin') {
            return this.user.url() + '/mppManagers';
        }

        return '/AppUsers';
    }

    initialize(models, {user = null}) {
        this.model = User;
        super.initialize(...arguments);
        this.searchableAttributes = ['name', 'username', 'role'];
        this.user = user;
        return this;
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/users.js